module.exports = __webpack_public_path__ + "img/dnr-app.168d0c29.svg";